import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Button from "../../../components/shared/components/button/Button.style";
import GeneralModal from "../../../components/shared/components/generalModal/GeneralModal.component";

import {
  deleteCampaignAction,
  setSelectedChannelIdAction,
  getCampaignsByChannelAction,
} from "../../../redux/campaignDuck";
import { dateFromNowLongVersion } from "../../../tools/date-utils";
import { getWhatsappActiveChannels } from "../../../utils/channels";
import { CAMPAIGN_STATUS_LABEL, CAMPAIGN_STATUS_VARIANT } from "../../../const/campaignStatus";
import useSedeMode from "../../../hooks/useSedeMode";

// New Design System Components
import {
  CampaignCard,
  TableToolbar,
  TableToolbarLeft,
  TableToolbarRight,
  CampaignTable,
  CampaignTableHead,
  CampaignTableBody,
  StatusBadge,
  TableLink,
  FormSelect,
} from "./Campaigns.style";

const statusLabel = CAMPAIGN_STATUS_LABEL;

const statusMap = CAMPAIGN_STATUS_VARIANT;

const BroadcastTable = ({ qualityRating }) => {
  const history = useHistory();
  // Partner access: the analytics page sends the normal token with the
  // sede's company id, so a sede tab gets no link into it. Creating a
  // campaign sends a channel credential (`pageToken`) the sede projection
  // strips, so a sede tab gets no way into the wizard either.
  const sedeMode = useSedeMode();

  const dispatch = useDispatch();
  const campaigns = useSelector((state) => state?.campaign?.data);
  const companyId = useSelector((state) => state?.user?.data?.company?.id);
  const selectedChannelId = useSelector(
    (state) => state?.campaign?.data?.create?.channelId,
  );

  const [loading, setLoading] = useState(false);
  const [isQualityModalOpen, setIsQualityModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [channels, setChannels] = useState([]);

  const goToCreate = () => {
    if (qualityRating === "Baja" || qualityRating === "Media") {
      setIsQualityModalOpen(true);
      return;
    }
    handleConfirmButton();
  };

  const handleConfirmButton = () => {
    history.push("/broadcast/type");
  };

  const handleDeleteCampaign = async () => {
    setLoadingDelete(true);
    await dispatch(deleteCampaignAction(selectedCampaign));
    setIsDeleteModalOpen(false);
    setLoadingDelete(false);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedCampaign(null);
  };

  const setSelectedChannel = (channelId) => {
    dispatch(setSelectedChannelIdAction(channelId));
    dispatch(getCampaignsByChannelAction(channelId));
  };

  const getCampaigns = async () => {
    const channelsFromDb = await getWhatsappActiveChannels(companyId);
    if (channelsFromDb?.length) {
      const channelsFormatted = channelsFromDb.map((x) => ({
        id: x.id,
        name: x.name,
        phone: x.phone,
      }));
      setChannels(channelsFormatted);
      dispatch(setSelectedChannelIdAction(channelsFormatted[0].id));
      dispatch(getCampaignsByChannelAction(channelsFormatted[0].id));
    }
  };

  useEffect(() => {
    if (companyId) getCampaigns();
  }, [companyId]);

  return (
    <>
      {loading && <div>Cargando...</div>}
      {!loading && (
        <CampaignCard>
          <TableToolbar>
            <TableToolbarLeft>
              <FormSelect
                value={selectedChannelId}
                onChange={(event) => setSelectedChannel(event.target.value)}
                style={{ width: "auto", minWidth: "200px" }}
              >
                {channels.map((channel, i) => (
                  <option value={channel.id} key={i}>
                    {channel.phone && channel.name !== channel.phone
                      ? channel.name + " - " + channel.phone
                      : channel.name}
                  </option>
                ))}
              </FormSelect>
            </TableToolbarLeft>
            <TableToolbarRight>
              {!sedeMode && (
                <Button designV4 onClick={goToCreate}>
                  + Crear Campaña
                </Button>
              )}
            </TableToolbarRight>
          </TableToolbar>

          <CampaignTable>
            <CampaignTableHead>
              <tr>
                <th>Nombre Campaña</th>
                <th>Etiqueta / Fuente</th>
                <th>Estado</th>
                <th>Último Envío</th>
                <th></th>
              </tr>
            </CampaignTableHead>
            <CampaignTableBody>
              {campaigns
                .filter((campaign) => campaign?.createdAt)
                .map((broadcast, key) => (
                  <tr key={key}>
                    <td>
                      <strong>{broadcast.name}</strong>
                    </td>
                    <td>
                      {broadcast.selectedTags?.length > 0
                        ? `Etiqueta: ${broadcast.selectedTags.reduce(
                            (pV, cV, i) =>
                              i === 0 ? cV.name : pV + ", " + cV.name,
                            "",
                          )}`
                        : "Archivo Excel"}
                    </td>
                    <td>
                      <StatusBadge
                        status={statusMap[broadcast.status] || "pending"}
                      >
                        {statusLabel[broadcast.status] || "Pendiente"}
                      </StatusBadge>
                    </td>
                    <td>
                      {broadcast.lastSendAt
                        ? dateFromNowLongVersion(broadcast.lastSendAt)
                        : "-"}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {!sedeMode && (
                        <TableLink
                          onClick={() => {
                            history.push(`/broadcast/analytics/${broadcast.id}`);
                          }}
                        >
                          Ver detalles
                        </TableLink>
                      )}
                    </td>
                  </tr>
                ))}
            </CampaignTableBody>
          </CampaignTable>
          {sedeMode && (
            <p style={{ margin: "16px 0 0", color: "#6B7280", fontSize: "0.85rem" }}>
              Crear campañas desde una sede estará disponible más adelante.
            </p>
          )}
        </CampaignCard>
      )}

      <GeneralModal
        type="broadcastQualityModal"
        mainText={""}
        show={isQualityModalOpen}
        broadcastquality={qualityRating}
        loadingForm={loadingDelete}
        handleConfirmButton={handleConfirmButton}
        handleCancelButton={() => {
          setIsQualityModalOpen(false);
        }}
      />

      <GeneralModal
        type="general"
        mainText="¿Seguro que quieres eliminar esta campaña?"
        show={isDeleteModalOpen}
        confirmText="Eliminar"
        cancelText="Cancelar"
        handleConfirmButton={handleDeleteCampaign}
        handleCancelButton={handleCloseDeleteModal}
      />
    </>
  );
};

export default BroadcastTable;
